import PropTypes from 'prop-types';
import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, MenuItem, Typography } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import { postTicketBoomerang } from '../../../../../api/tickets';
import { useSnackbar } from '../../../../../reusable-components/snackbar';
import { inXHours, inThreeDays, tomorrow } from '../RemindMeTimers';
import { fDateTime } from '../../../../../utils/formatTime';

RemindMeDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  ticket: PropTypes.object,
  unpinTicket: PropTypes.func,
  boomerang: PropTypes.object,
};

export default function RemindMeDialog({ open, onClose, ticket, unpinTicket, boomerang }) {
  const [showCustom, setShowCustom] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const updateRemindMe = async (date) => {
    try {
      const response = await postTicketBoomerang({ date, ticketId: ticket.id });
      if (response.status === 200 || (response.status === 204 && !date)) {
        unpinTicket(date);
        if (enqueueSnackbar) enqueueSnackbar('Reminder set successfully', { variant: 'success' });
      } else if (enqueueSnackbar) {
        enqueueSnackbar('Failed to set reminder', { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('Failed to set reminder', { variant: 'error' });
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        onClose();
      }}
    >
      <DialogTitle>Remind Me</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 1 }}>
          {boomerang?.boomerangOn
            ? `Reminder set for ${fDateTime(boomerang?.boomerangOn)}`
            : 'Set a reminder for this ticket.'}
        </Typography>
        <MenuItem onClick={() => updateRemindMe(inXHours(1))}>In one hour</MenuItem>
        <MenuItem onClick={() => updateRemindMe(tomorrow())}>Tomorrow</MenuItem>
        <MenuItem onClick={() => updateRemindMe(inThreeDays())}>In three days</MenuItem>
        <MenuItem onClick={() => setShowCustom(true)}>Custom time</MenuItem>
        {showCustom && (
          <DateTimePicker
            minDate={new Date()}
            slotProps={{
              textField: { size: 'small', sx: { minWidth: 240 } },
              actionBar: { actions: ['clear', 'cancel', 'accept'] },
            }}
            value={boomerang?.boomerangOn ? new Date(boomerang?.boomerangOn) : null}
            onAccept={(dateValue) => {
              updateRemindMe(dateValue);
              setShowCustom(false);
            }}
            onClose={() => setShowCustom(false)}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}